import { ProgramContent } from "../types/service.type";
import { EquipmentCategory } from "../enum/service.enum";

export const getTotalDistinctEquipments = (programContents?: ProgramContent[]): number => {
  if (!programContents?.length) return 0;

  const distinctEquipments = new Set<string>();

  programContents.forEach((content) => {
    const { equipments } = content;

    equipments.ball_control_and_agility?.forEach((equipment) => distinctEquipments.add(equipment));
    equipments.strength_and_power?.forEach((equipment) => distinctEquipments.add(equipment));
    equipments.endurance_and_speed?.forEach((equipment) => distinctEquipments.add(equipment));
    equipments.rehabilitation_and_recovery?.forEach((equipment) => distinctEquipments.add(equipment));
    equipments.specialized_training?.forEach((equipment) => distinctEquipments.add(equipment));
  });

  return distinctEquipments.size;
};

export const getServiceEquipments = (programContents?: ProgramContent[]) => {
  const equipments: { [key in EquipmentCategory]: string[] } = {
    ball_control_and_agility: [],
    strength_and_power: [],
    endurance_and_speed: [],
    rehabilitation_and_recovery: [],
    specialized_training: [],
  };

  if (!programContents?.length) return equipments;

  programContents.forEach((content) => {
    const { equipments: contentEquipments } = content;

    Object.keys(contentEquipments).forEach((category) => {
      if (category in equipments) {
        const existingEquipments = equipments[category as EquipmentCategory] || [];
        const newEquipments = contentEquipments[category as EquipmentCategory] || [];
        equipments[category as EquipmentCategory] = Array.from(new Set([...existingEquipments, ...newEquipments]));
      }
    });
  });

  return equipments;
};
